<template>
  <!-- Все тексты и картинки главной редактируются в админке: Сайт → Главная страница -->
  <greeting-section :content="home"></greeting-section>
  <manufacters-section :content="home"></manufacters-section>
  <our-values-section :content="home"></our-values-section>
  <features-section :content="home"></features-section>
  <questions-section></questions-section>
  <feedback-block :content="home"></feedback-block>
  <contacts-section></contacts-section>
</template>

<script setup>
import GreetingSection from "./greeting/GreetingSection.vue";
import ManufactersSection from "./manufacturers/ManufactersSection.vue";
import OurValuesSection from "./ourValues/ourValuesSection.vue";
import FeaturesSection from "./features/FeaturesSection.vue";
import QuestionsSection from "./questions/QuestionsSection.vue";
import FeedbackBlock from "./feedback/FeedbackBlock.vue";
import ContactsSection from "./contacts/ContactsSection.vue";
import {onMounted} from "vue";
import {useSiteSettings} from "@/functions/siteSettings";

const home = useSiteSettings('home');

onMounted(() => {
  window.scrollTo({
    top: 1,
    behavior: "smooth",
  });
});
</script>

<style></style>
